import React, { useState } from "react";
import ParticlesBg from "particles-bg";
import { message } from "antd";
import {
  Button,
  TextField,
  Alert,
  Backdrop,
  Dialog,
  Divider,
} from "@mui/material";
import { CircularProgress } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import api from "./request";
import "./index.css";

const initData = {
  qq: "",
  phone: "",
  LolQQ: "",
  LolName: "",
  wbid: "",
  wbphone: "",
  qqlm: "",
};
const initUserInfo = {
  phone: "",
  phonediqu: "",
  qq: "",
  name: "",
  daqu: "",
  qqlm: "",
  id: "",
};

function App() {
  const [dialog, setDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(initData);
  const [userInfo, setUserInfo] = useState(initUserInfo);
  const search = async (type: string) => {
    setLoading(true);
    // const res = await api[type](data[type]);
    switch (type) {
      case "qq":
        const qq = await api.qq(data.qq);

        if (qq.data.status === 200) {
          message.success(qq.data.message);
          setLoading(false);
          setDialog(true);
        } else {
          message.error(qq.data.message);
          setLoading(false);
        }
        setUserInfo({
          phone: qq.data.phone || "-",
          phonediqu: qq.data.phonediqu || "-",
          qq: qq.data.qq || "-",
          name: qq.data.name || "-",
          daqu: qq.data.daqu || "-",
          qqlm: qq.data.qqlm || "-",
          id: qq.data.id || "-",
        });
        break;
      case "phone":
        const phone = await api.phone(data.phone);

        if (phone.data.status === 200) {
          message.success(phone.data.message);
          setLoading(false);
          setDialog(true);
        } else {
          message.error(phone.data.message);
          setLoading(false);
        }
        setUserInfo({
          phone: phone.data.phone || "-",
          phonediqu: phone.data.phonediqu || "-",
          qq: phone.data.qq || "-",
          name: phone.data.name || "-",
          daqu: phone.data.daqu || "-",
          qqlm: phone.data.qqlm || "-",
          id: phone.data.id || "-",
        });
        break;
      case "LolQQ":
        const LolQQ = await api.LolQQ(data.LolQQ);
        if (LolQQ.data.status === 200) {
          message.success(LolQQ.data.message);
          setLoading(false);
          setDialog(true);
        } else {
          message.error(LolQQ.data.message);
          setLoading(false);
        }
        setUserInfo({
          phone: LolQQ.data.phone || "-",
          phonediqu: LolQQ.data.phonediqu || "-",
          qq: LolQQ.data.qq || "-",
          name: LolQQ.data.name || "-",
          daqu: LolQQ.data.daqu || "-",
          qqlm: LolQQ.data.qqlm || "-",
          id: LolQQ.data.id || "-",
        });
        break;
      case "LolName":
        const LolName = await api.LolName(data.LolName);
        if (LolName.data.status === 200) {
          message.success(LolName.data.message);
          setLoading(false);
          setDialog(true);
        } else {
          message.error(LolName.data.message);
          setLoading(false);
        }
        setUserInfo({
          phone: LolName.data.phone || "-",
          phonediqu: LolName.data.phonediqu || "-",
          qq: LolName.data.qq || "-",
          name: LolName.data.name || "-",
          daqu: LolName.data.daqu || "-",
          qqlm: LolName.data.qqlm || "-",
          id: LolName.data.id || "-",
        });
        break;
      case "wbid":
        const wbid = await api.wbid(data.wbid);
        if (wbid.data.status === 200) {
          message.success(wbid.data.message);
          setLoading(false);
          setDialog(true);
        } else {
          message.error(wbid.data.message);
          setLoading(false);
        }
        setUserInfo({
          phone: wbid.data.phone || "-",
          phonediqu: wbid.data.phonediqu || "-",
          qq: wbid.data.qq || "-",
          name: wbid.data.name || "-",
          daqu: wbid.data.daqu || "-",
          qqlm: wbid.data.qqlm || "-",
          id: wbid.data.id || "-",
        });
        break;
      case "wbphone":
        const wbphone = await api.wbphone(data.wbphone);
        if (wbphone.data.status === 200) {
          message.success(wbphone.data.message);
          setLoading(false);
          setDialog(true);
        } else {
          message.error(wbphone.data.message);
          setLoading(false);
        }
        setUserInfo({
          phone: wbphone.data.phone || "-",
          phonediqu: wbphone.data.phonediqu || "-",
          qq: wbphone.data.qq || "-",
          name: wbphone.data.name || "-",
          daqu: wbphone.data.daqu || "-",
          qqlm: wbphone.data.qqlm || "-",
          id: wbphone.data.id || "-",
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="App">
      <div className="Box ">
        <Alert severity="warning">
          本站仅为个人信息数据泄漏检测！<br></br>请勿违法使用，后果自负！
        </Alert>
        <p>QQ查询绑定手机:</p>
        <div className="item">
          <TextField
            id="outlined-basic"
            label="请输入QQ号"
            variant="outlined"
            size="small"
            value={data.qq}
            autoComplete="off"
            onChange={(e) => setData({ ...data, qq: e.target.value.trim() })}
          />
          <Button
            onClick={() => search("qq")}
            variant="outlined"
            size="medium"
            disabled={
              data.qq.length === 0
                ? true
                : data.qq === "2889984509"
                ? true
                : false
            }
          >
            查询
          </Button>
        </div>
        <p>手机查询绑定QQ:</p>
        <div className="item">
          <TextField
            id="outlined-basic"
            label="请输入手机号"
            variant="outlined"
            size="small"
            value={data.phone}
            autoComplete="off"
            onChange={(e) => setData({ ...data, phone: e.target.value.trim() })}
          />
          <Button
            variant="outlined"
            size="medium"
            onClick={() => search("phone")}
            disabled={data.phone.length === 0 ? true : false}
          >
            查询
          </Button>
        </div>
        <p>QQ查询LOL信息:</p>
        <div className="item">
          <TextField
            id="outlined-basic"
            label="请输入QQ号"
            variant="outlined"
            size="small"
            value={data.LolQQ}
            autoComplete="off"
            onChange={(e) => setData({ ...data, LolQQ: e.target.value.trim() })}
          />
          <Button
            variant="outlined"
            size="medium"
            onClick={() => search("LolQQ")}
            disabled={
              data.LolQQ.length === 0
                ? true
                : data.LolQQ === "2889984509"
                ? true
                : false
            }
          >
            查询
          </Button>
        </div>
        <p>LOL查询QQ信息:</p>
        <div className="item">
          <TextField
            id="outlined-basic"
            label="请输入LOL昵称"
            variant="outlined"
            size="small"
            value={data.LolName}
            autoComplete="off"
            onChange={(e) =>
              setData({ ...data, LolName: e.target.value.trim() })
            }
          />
          <Button
            variant="outlined"
            size="medium"
            onClick={() => search("LolName")}
            disabled={data.LolName.length === 0 ? true : false}
          >
            查询
          </Button>
        </div>
        <p>手机查询微博ID:</p>
        <div className="item">
          <TextField
            id="outlined-basic"
            label="请输入手机号"
            variant="outlined"
            size="small"
            value={data.wbid}
            autoComplete="off"
            onChange={(e) => setData({ ...data, wbid: e.target.value.trim() })}
          />
          <Button
            variant="outlined"
            size="medium"
            onClick={() => search("wbid")}
            disabled={data.wbid.length === 0 ? true : false}
          >
            查询
          </Button>
        </div>
        <p>微博ID查询手机:</p>
        <div className="item">
          <TextField
            id="outlined-basic"
            label="请输入微博ID"
            variant="outlined"
            size="small"
            value={data.wbphone}
            autoComplete="off"
            onChange={(e) =>
              setData({ ...data, wbphone: e.target.value.trim() })
            }
          />
          <Button
            variant="outlined"
            size="medium"
            onClick={() => search("wbphone")}
            disabled={data.wbphone.length === 0 ? true : false}
          >
            查询
          </Button>
        </div>
      </div>
      <ParticlesBg type="square" bg={true} />
      <Backdrop sx={{ color: "#fff", zIndex: "1000" }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Dialog open={dialog}>
        <div>
          <List component="nav" aria-label="mailbox folders">
            <ListItem button divider>
              QQ号：{userInfo.qq}
            </ListItem>
            <ListItem button divider>
              手机号：{userInfo.phone}
            </ListItem>
            <ListItem button divider>
              归属地：{userInfo.phonediqu}
            </ListItem>
            <ListItem button divider>
              LOL昵称：{userInfo.name}
            </ListItem>
            <ListItem button divider>
              LOL大区：{userInfo.daqu}
            </ListItem>
            <ListItem button divider>
              微博ID：{userInfo.id}
            </ListItem>
            <ListItem button>
              <div style={{ textAlign: "center", width: "100%" }}>
                <Button variant="contained" onClick={() => setDialog(false)}>
                  关闭
                </Button>
              </div>
            </ListItem>
          </List>
        </div>
      </Dialog>
    </div>
  );
}

export default App;
